import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getTrackBackground, Range } from 'react-range';

const propTypes = {
  values: PropTypes.array.isRequired,
  colors: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
};

const RangeSlider = ({
  values,
  colors = ['#0d84fe', '#f2f3f3'],
  onChange,
  min,
  max,
  className,
  ...props
}) => {
  const classes = classNames({
    'range-slider': true,
    [className]: !!className,
  });

  return (
    <Range
      values={values}
      onChange={onChange}
      renderTrack={({ props: trackProps, children }) => (
        <div
          role="button"
          tabIndex={0}
          onMouseDown={trackProps.onMouseDown}
          onTouchStart={trackProps.onTouchStart}
          className={classes}
        >
          <div
            ref={trackProps.ref}
            className="range-slider-track"
            style={{
              background: getTrackBackground({
                values,
                colors,
                min,
                max,
              }),
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ props: thumbProps }) => (
        <div {...thumbProps} className="range-slider-thumb" />
      )}
      min={min}
      max={max}
      {...props}
    />
  );
};

RangeSlider.propTypes = propTypes;

export default RangeSlider;
